import React from 'react';
import { Play, FileText } from 'lucide-react';
import { Instructor } from '../data/instructors';

interface InstructorLibraryProps {
  instructors: Instructor[];
}

export function InstructorLibrary({ instructors }: InstructorLibraryProps) {
  return (
    <div className="space-y-12">
      {instructors.map((instructor) => (
        <div key={instructor.id} className="bg-white p-8 rounded-[30px] shadow-xl space-y-8">
          <div className="flex items-start gap-6">
            <img
              src={instructor.avatar}
              alt={instructor.name}
              className="w-24 h-24 rounded-2xl object-cover shadow-lg"
            />
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-gray-700">{instructor.name}</h2>
              <p className="text-custom-orange-400 font-medium">{instructor.title}</p>
              <p className="mt-2 text-gray-600">{instructor.bio}</p>
              <div className="flex gap-2 mt-3">
                {instructor.specialties.map((specialty, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-custom-orange-50 text-custom-orange-400 rounded-xl text-sm"
                  >
                    {specialty}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {instructor.content.map((content, index) => (
              <div key={index} className="group relative">
                <div className="aspect-video rounded-xl overflow-hidden">
                  <img
                    src={content.thumbnail}
                    alt={content.title}
                    className="w-full h-full object-cover transition-transform group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <a
                      href={content.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-custom-orange-400 transform -translate-y-2 group-hover:translate-y-0 transition-transform"
                    >
                      {content.type === 'video' ? (
                        <Play size={24} />
                      ) : (
                        <FileText size={24} />
                      )}
                    </a>
                  </div>
                </div>
                <div className="mt-3">
                  <h3 className="font-semibold text-gray-700">{content.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{content.description}</p>
                  {content.duration && (
                    <span className="text-xs text-custom-orange-400 mt-2 block">
                      {content.duration}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}